module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "uncategorized-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Praise For CJ Carver")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘A shocking, complex and beautifully written thriller and another cracker from the pen of bestseller CJ Carver’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Reader’s Retreat")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘CJ Carver can do no wrong. Fabulous. Extremely fabulous. Read this series. It’s the best!’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Northern Crime")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘A fast and ingenious thriller that pits the brilliantly addictive Forrester and Davies against a tense and chillingly real conspiracy… I’m full of admiration’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Isabelle Grey, author")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘This is an extraordinarily tense, clever thriller. Don’t expect to sleep, because this is unputdownable’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Frost Magazine")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘A terrific page-turner. Heart-stopping action and a heroine with guile as well as guts’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Harlen Coben, author")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘Anyone who is a member of a book club should be recommending ("), _c('i', [_vm._v("Spare Me the Truth")]), _vm._v(") to their fellow readers with great gusto’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Book Addict Shawn")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘Carver gives us strong heroines battling against the odds, fast-moving plots and a strong sense of place. She deservedly won the CWA Debut Dagger for "), _c('i', [_vm._v("Blood Junction")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Publishing News")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("“I’m so glad this is the first of a series: I want more… and I want it now!’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Julia Crouch, author")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘Fast, smart and furious… it will have you clinging on by your fingertips. CJ Carver is one of the best thriller writers working today’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Tom Harper, former CWA Chairman")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘A complex tale of betrayal and deception. CJ Carver writes with compassion about characters she really cares about’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Parker Bilal, author")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘A top-notch thriller writer. CJ Carver is one of the best’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Simon Kernick, author")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘A high-wire act of a thriller, with a plot as ingeniously constructed as a sudoku puzzle’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("The Lady Magazine")])])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("‘Powerful writing, a gripping plot and a unique setting… outstanding’")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("The Mystery and Thriller Club")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129025c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praise-for-cj-carver.vue
// module id = 72
// module chunks = 0